import { appUrl } from "@astro/config"

export const SYSTEM_LINKS = [
  { label: 'About Us', href: appUrl("website", "about") },
  { label: 'Book Consultation', href: appUrl("jyotish", "consultations") },
  { label: 'Media Gallery', href: appUrl("jyotish", "gallery") },
  { label: 'Blogs', href: appUrl("website", "blog") },
  { label: 'Make a Donation', href: appUrl("website") },
  { label: 'Contact Us', href: appUrl("website", "contact") },
]

export const OFFERING_LINKS = [
  { label: 'Daily Horoscopes', href: appUrl("website", "horoscope") },
  { label: 'Kundli Matching', href: appUrl("website", "astro-tools") },
  { label: 'Vastu Consultation', href: appUrl("jyotish", "consultations") },
  { label: 'Gemstone System', href: appUrl("shop", "products") },
  { label: 'Palmistry Check', href: appUrl("jyotish", "maharaj-ji") },
  { label: 'Online Classes', href: appUrl("education", "classes") },
]

// Absolute URLs so the same links work from every app (the legal pages all
// live on the main website app, in `apps/website/src/pages/legal/`). Shipping,
// cancellation/refund and grievance links have to be reachable from the shop
// and checkout too, which is why they sit in the shared footer rather than on
// the website only.
export const LEGAL_LINKS = [
  { label: 'Terms of Service', href: appUrl("website", "terms-of-service") },
  { label: 'Privacy Policy', href: appUrl("website", "privacy-policy") },
  { label: 'Cookie Policy', href: appUrl("website", "cookie-policy") },
  { label: 'Cancellation & Refund', href: appUrl("website", "refund-policy") },
  { label: 'Shipping & Delivery', href: appUrl("website", "shipping-policy") },
  { label: 'Disclaimer', href: appUrl("website", "disclaimer") },
  { label: 'Grievance Redressal', href: appUrl("website", "grievance-redressal") },
]
